<template>
<section class="page-our-rooms">
  <div class="qbk-header">
    <img src="../assets/images/logo-red.svg" alt="">
  </div>
  <div class="qbk-wrap">
    <div class="row qbk-or-box">
      <div class="col-12 col-md-8">
        <div class="qbk-hotels-item" v-for="(r,rIndex) in room" :key="'qbk-hot-item-'+rIndex">
          <div class="row no-gutters">
            <div class="col-12 col-md-6 qbk-hot-image">
              <img :src="r.image" alt="" class="img-fluid w-100">
            </div>
            <div class="col-12 col-md-6 qbk-hot-content">
              <h1>{{r.title}}</h1>
              <div v-html="r.content"></div>
              <div class="qbk-hot-nav">
                <!-- <label>
                  from Rp {{thousand(r.price)}} / night
                </label> -->
                <router-link :to="`/room/${r.id}`">
                  View Details >
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="qbk-book-box">
          <div class="row">
            <div class="col-12">
              <label class="book">Check In</label>
              <b-form-datepicker :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" locale="id" v-model="date.in"/>
            </div>
            <div class="col-12">
              <label class="book">Check Out</label>
              <b-form-datepicker :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" locale="id" v-model="date.out"/>
            </div>
            <div class="col-12">
              <a :href="`https://www.e1-booking.com/booking/booking-page.php?id=1526&checkin=${date.in}&checkout=${date.out}`" target="_blank">
              <button type="button" class="book">Check Availability</button>
              </a>
            </div>
          </div>
        </div>
        <div class="qbk-right-list">
          <h2><b>Our Promo</b></h2>
          <ul>
            <li v-for="(ar,arIndex) in promo" :key="'qbk-room-article-'+arIndex">
              <router-link :to="`/promo/${ar.id}`">
              <div>
                <img :src="ar.image" alt="Hotel">
              </div>
              <div>
                <h4>{{ar.title}}</h4>
                <p>{{limitWord(ar.content,100)}}...</p>
              </div>
              </router-link>
            </li>
          </ul>
        </div>
        <!-- <div class="qbk-right-list">
          <h2><b>Tags</b></h2>
          <div class="qbk-rl-tags">
            <a href="#">Accomodation</a>
            <a href="#">Hotel</a>
            <a href="#">Room</a>
            <a href="#">BSD</a>
            <a href="#">Jakarta</a>
            <a href="#">Qubika</a>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</section>
</template>

<script>
import axios from 'axios'
import {
  baseUrl
} from '../config'
export default {
  data() {
    return {
      room: [{
          img: require(`../assets/images/room/superior.jpg`),
          name: `Superior Room`,
          desc: `As the smallest sized room,  this room design prioritizes comfort with a complete facility and will make you sink into the the comfort offered by this Superior Room.`,
          details: [{
              title: `Maks`,
              content: `2 Tamu`
            },
            {
              title: `Luas Kamar`,
              content: `14 m`
            },
            {
              title: `Jenis Bed`,
              content: `Twin bed`
            },
            {
              title: `Room Facilities`,
              content: `Telephone, Working desk, AC, Led TV With 40 Channels, Wifi , Laundry & Dry Cleaning Service`
            }
          ],
          rate: {
            cost: 458000,
            desc: `Nett (Include Breakfast)`
          }
        },
        {
          img: require(`../assets/images/room/deluxe.jpg`),
          name: `Deluxe Room`,
          desc: `Deluxe Room is furnished with exclusive furniture and various supporting facilities. Available in a queen beds, with city views.`,
          details: [{
              title: `Maks`,
              content: `2 Tamu`
            },
            {
              title: `Luas Kamar`,
              content: `24 m`
            },
            {
              title: `Jenis Bed`,
              content: `Double/ Queen bed`
            },
            {
              title: `Room Facilities`,
              content: `Telephone, Working desk, AC, Led TV With 40 Channels, Wifi , Laundry & Dry Cleaning Service`
            }
          ],
          rate: {
            cost: 558000,
            desc: `Nett (Include Breakfast)`
          }
        },
        {
          img: require(`../assets/images/room/suite.jpg`),
          name: `Suite Room`,
          desc: `Suite rooms with modern  designs and combined with wood elements provide comfort and luxury in each room. `,
          details: [{
              title: `Maks`,
              content: `2 Tamu`
            },
            {
              title: `Luas Kamar`,
              content: `30 m`
            },
            {
              title: `Jenis Bed`,
              content: `Double/ Queen bed`
            },
            {
              title: `Room Facilities`,
              content: `Telephone, Working desk, AC, Led TV With 40 Channels, Wifi , Laundry & Dry Cleaning Service`
            }
          ],
          rate: {
            cost: 658000,
            desc: `Nett (Include Breakfast)`
          }
        },
        {
          img: require(`../assets/images/room/club-suite.jpg`),
          name: `Club Suite Room`,
          desc: `Club suite room has a spacious room with a modern design.  Facilities include air conditioning, LED TV with 40 channels, Mini bar, Coffee and tea makers, hot & cold bathing with standing shower, high comfortable mattress bed, and a complimentary high speed WIFI internet connection `,
          details: [{
              title: `Maks`,
              content: `2 Tamu`
            },
            {
              title: `Luas Kamar`,
              content: `42 m`
            },
            {
              title: `Jenis Bed`,
              content: `Double/ Queen bed`
            },
            {
              title: `Room Facilities`,
              content: `Telephone, Working desk, AC, Led TV With 40 Channels, Wifi , Laundry & Dry Cleaning Service`
            }
          ],
          rate: {
            cost: 958000,
            desc: `Nett (Include Breakfast)`
          }
        },
      ],
      date: {
        in : null,
        out: null,
      },
      promo: []
    }
  },
  methods: {
    loadRoom() {
      let url = `${baseUrl}/api/post`
      let payload = {
        perPage: '~',
        type: 'ROOM ITEM',
        sortDir: 'asc',
        sortBy : 'id',
      }
      axios
        .post(url, payload)
        .then((res) => {
          let data = res.data.data
          data.map((x) => {
            x.child.map((z) => {
              if (z.type == 'ROOM ITEM PRICE')
                x.price = z.content
            })
          })
          this.room = data
        })
        .catch((e) => {
          this.notif('Error', e.message, 'error')
        })
    },
    loadPromo(){
      let url = `${baseUrl}/api/post`
      let payload = {
        perPage : 4,
        type : 'PROMO ITEM'
      }
      axios
      .post(url,payload)
      .then((res)=>{
        let data = res.data.data
        this.promo = data
      })
      .catch((e)=>{
        this.notif('Error',e.message,'error')
      })
    },
    thousand(num) {
      if (num) {
        let num_parts = num.toString().split(",");
        num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return num_parts.join(",");
      } else {
        return 0
      }
    },
    notif(title, msg, type) {
      this.$bvToast.toast(msg, {
        title: title,
        autoHideDelay: 5000,
        variant: type,
        solid: true,
        toaster: 'b-toaster-bottom-left'
      })
    },
    limitWord(yourString,maxLength){
      let string = yourString.replace(/<[^>]*>?/gm, '');
      //trim the string to the maximum length
      var trimmedString = string.substr(0, maxLength);

      //re-trim if we are in the middle of a word
      return trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")))
    },
  },
  mounted() {
    this.loadRoom()
    this.loadPromo()
  }
}
</script>
